module.exports = __webpack_public_path__ + "static/media/weather-app-min.e5dd6ba9.png";